import { gql } from '@apollo/client';

export const DELETE_LINKED_ACCOUNT = gql`
  mutation deleteUserAccount($id: String!) {
    deleteUserAccount(id: $id) {
      success
    }
  }
`;
